module.exports = __webpack_public_path__ + "img/组16@3x.de44406f.png";